
import {INotificationFilterTypeStrategy} from '@toolify/client/src/stores/NotificationStore/types/INotificationFilterTypeStrategy'
import {INotificationResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/INotificationResponseInstance'
import {NotificationFilterType} from '@toolify/server/src/controllers/NotificationController/enum/NotificationFilterType'
import {NotificationType} from '@toolify/server/src/models/mongoose/NotificationModel/enum/NotificationType'

export class UnreadNotificationFilterTypeStrategy implements INotificationFilterTypeStrategy {
  updateNotificationsByNotificationFilterTypeMap(notificationsByNotificationFilterTypeMap: Map<NotificationFilterType, INotificationResponseInstance<NotificationType>[]>): Map<NotificationFilterType, INotificationResponseInstance<NotificationType>[]> {
    const newMap = new Map(notificationsByNotificationFilterTypeMap)
    const assignedToMeNotifications = notificationsByNotificationFilterTypeMap.get(NotificationFilterType.AssignedToMe) || []
    const mentionedInMessageNotifications = notificationsByNotificationFilterTypeMap.get(NotificationFilterType.Mentions) || []
    const allNotifications = notificationsByNotificationFilterTypeMap.get(NotificationFilterType.All) || []
    const unreadNotifications = notificationsByNotificationFilterTypeMap.get(NotificationFilterType.Unread) || []

    const updatedUnreadNotifications = unreadNotifications.map(notification => {
      if (!notification.readAt) {
        notification.readAt = new Date()
        notification.unreadGroupCount = 0
      }
      return notification
    })
    const updatedAssignedToMeNotifications = assignedToMeNotifications.map(notification => {
      if (!notification.readAt) {
        notification.readAt = new Date()
        notification.unreadGroupCount = 0
      }
      return notification
    })
    const updatedMentionedInMessageNotifications = mentionedInMessageNotifications.map(notification => {
      if (!notification.readAt) {
        notification.readAt = new Date()
        notification.unreadGroupCount = 0
      }
      return notification
    })
    const updatedAllNotifications = allNotifications.map(notification => {
      if (!notification.readAt) {
        notification.readAt = new Date()
        notification.unreadGroupCount = 0
      }
      return notification
    })

    newMap.set(NotificationFilterType.Unread, updatedUnreadNotifications)
    if (notificationsByNotificationFilterTypeMap.has(NotificationFilterType.AssignedToMe)) {
      newMap.set(NotificationFilterType.AssignedToMe, updatedAssignedToMeNotifications)
    }
    if (notificationsByNotificationFilterTypeMap.has(NotificationFilterType.Mentions)) {
      newMap.set(NotificationFilterType.Mentions, updatedMentionedInMessageNotifications)
    }
    if (notificationsByNotificationFilterTypeMap.has(NotificationFilterType.All)) {
      newMap.set(NotificationFilterType.All, updatedAllNotifications)
    }
    return newMap
  }
  isNotificationMatchingFilterType(notification: INotificationResponseInstance<NotificationType>): boolean {
    return !notification.readAt
  }
}
